export default __webpack_public_path__ + "static/media/cart-icon.db5aad12.svg";